import { images } from '../data/gallery';
import {
    SHOW_HIDE_GALLERY,
    SET_CURRENT_IMAGE,
    CHANGE_IMAGE_GALLERY,
  } from '../utils/actions'


  const website_reducer = (state, action) => {

    if(action.type === SHOW_HIDE_GALLERY) {
        return {...state, galleryON: !state.galleryON} 
     }
     if(action.type === SET_CURRENT_IMAGE) {
        return {...state, currentImg: action.payload} 
     }

     if(action.type === CHANGE_IMAGE_GALLERY) {

        const buttonType = action.payload;

        if(buttonType === 'left') {
            if(state.currentImg === 0){
                return {
                    ...state, 
                    currentImg: images.length - 1,
                  }
              } else {
                return {
                    ...state, 
                    currentImg: state.currentImg - 1
                  }
              }
        } else if(buttonType === 'right') {
            if(state.currentImg === images.length - 1){
                return {
                    ...state, 
                    currentImg: 0,
                  }
              } else {
                return {
                    ...state, 
                    currentImg: state.currentImg + 1
                  }
              }  
        }
        

     }

    throw new Error(`No Matching "${action.type}" - action type`)
  }


  export default website_reducer